import { getSettingPauseInsiderMembershipEnabled } from "@faire/retailer/settings/getSettingPauseInsiderMembershipEnabled";
import { useSettingEnableInsiderAUSCANLaunch } from "@faire/retailer/settings/useSettingEnableInsiderAUSCANLaunch";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const useInsiderFeatureEligibility = () => {
  const enableInsiderAUSCANLaunch = useSettingEnableInsiderAUSCANLaunch();
  const { isAmerican, isCanadian, isEurope, isAustralian } = useRetailerStore([
    "isCanadian",
    "isAmerican",
    "isEurope",
    "isAustralian",
  ]);

  const ignoreThresholdAdvertising =
    (isCanadian || isAustralian) && enableInsiderAUSCANLaunch;
  const hasFreeDutyAdvertising = isEurope;
  const hasPhoneSupport =
    isAmerican || (isCanadian && enableInsiderAUSCANLaunch);
  const hasReverseSeason = isAustralian;
  const hasProtectedEarlyAccessPerk =
    isAmerican || ((isCanadian || isAustralian) && enableInsiderAUSCANLaunch);
  const hasSpecialTestimonial = isEurope;
  const hasSavingsBreakdown = isAmerican || isEurope;
  const hasNewPromoBanner =
    (isCanadian || isAustralian) && enableInsiderAUSCANLaunch;
  const hasMembershipTaxDisclaimer =
    (isCanadian || isAustralian) && enableInsiderAUSCANLaunch;
  const hasPauseMembershipFeature =
    isAmerican ||
    ((isCanadian || isAustralian) &&
      enableInsiderAUSCANLaunch &&
      getSettingPauseInsiderMembershipEnabled());

  return {
    hasFreeDutyAdvertising,
    hasPhoneSupport,
    hasProtectedEarlyAccessPerk,
    hasSavingsBreakdown,
    hasSpecialTestimonial,
    hasReverseSeason,
    ignoreThresholdAdvertising,
    hasNewPromoBanner,
    hasMembershipTaxDisclaimer,
    hasPauseMembershipFeature,
  };
};
